/**
 * 审核状态
 * NEW           新建 CONTENT_NEW
 * STAY_AUDIT    待审核 CONTENT_AUDITING
 * ALREADY_AUDIT 已审核 CONTENT_AUDITED
 * PUBLISHED     已发布 CONTENT_PUBLISHED
 * PUBLISHING    发布中 CONTENT_PUBLISHING
 * 4             已下架 CONTENT_OBTAINED（暂时取消）
 * MODIFIED      已修改 CONTENT_MODIFY
 */

export const CONTENT_NEW = 'NEW';
export const CONTENT_AUDITING = 'STAY_AUDIT';
export const CONTENT_AUDITED = 'ALREADY_AUDIT';
export const CONTENT_PUBLISHED = 'PUBLISHED';
export const CONTENT_OFFLINE = 'OFFLINE';
export const CONTENT_EDITING = 'EDITING';
export const CONTENT_MODIFY = 'MODIFIED';
export const CONTENT_PUBLISHING = 'PUBLISHING';

export const contentStatusMap = {
  [CONTENT_NEW]: '草稿',
  [CONTENT_AUDITING]: '待审核',
  [CONTENT_AUDITED]: '已审核',
  [CONTENT_PUBLISHED]: '已发布',
  [CONTENT_OFFLINE]: '已下架',
  [CONTENT_EDITING]: '修改中',
  [CONTENT_MODIFY]: '已修改',
  [CONTENT_PUBLISHING]: '发布中',
};
